import clsx from 'clsx'

import { Badge } from '@wartek-id/badge'
import { Text } from '@wartek-id/text-v1'

import { PENETAPAN_PEGAWAI_PREDIKAT_RATING_OPTIONS } from 'app/KinerjaTimPenilaiPSPage/constants/penetapan'

import type { PenetapanPredikatKinerjaRating } from 'types/kinerja-ps-pegawai'
import type { PenetapanPegawaiState } from 'types/kinerja-ps-pegawai'

type BadgePredikatKinerjaProps = {
  predicate: PenetapanPredikatKinerjaRating | 'UNDEFINED'
  status: PenetapanPegawaiState
  variant?: 'text' | 'badge'
}

type ColorSpecs = { foreground: string; background: string }

const COLORS: Record<PenetapanPredikatKinerjaRating, ColorSpecs> = {
  VERY_GOOD: {
    foreground: '!text-green-70',
    background: '!bg-green-10',
  },
  GOOD: {
    foreground: '!text-green-70',
    background: '!bg-green-5',
  },
  NEED_IMPROVEMENT: {
    foreground: '!text-yellow-600',
    background: '!bg-orange-5',
  },
  BAD: {
    foreground: '!text-red-70',
    background: '!bg-red-5',
  },
  VERY_BAD: {
    foreground: '!text-red-60',
    background: '!bg-red-10',
  },
  NOT_SET: {
    foreground: '!text-default',
    background: '!bg-gray-10',
  },
}

const DEFAULT_COLORS: ColorSpecs = {
  foreground: '!text-default',
  background: '!bg-gray-10',
}

export function BadgePredikatKinerja({
  predicate,
  status,
}: BadgePredikatKinerjaProps) {
  const label = PENETAPAN_PEGAWAI_PREDIKAT_RATING_OPTIONS[predicate]
  const colors = COLORS[predicate] ?? DEFAULT_COLORS
  const isNotRated = ['', 'NOT_RATED'].includes(status)

  if (isNotRated) {
    return <Badge variant="neutral">Penilaian Belum Selesai</Badge>
  }

  return (
    <Badge
      variant="success"
      className={clsx([colors.background, '!text-default'])}
    >
      <Text variant="body-sm" className="!font-semibold">
        {label ?? 'Belum Ditetapkan'}
      </Text>
    </Badge>
  )
}
